var _excluded = ["children"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import MuiTable from '@material-ui/core/Table';
function Table(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MuiTable, rest, children);
}
Table.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * React component, HTML node, string etc..
   */
  children: PropTypes.node.isRequired
} : {};
export default Table;